<icon [hidden]="showTaskActionSelect" type="square-plus" (click)="taskActionSelectFocus()" />
<custom-select #selectTaskActionType
               [hidden]="!showTaskActionSelect"
               [label]="'taskflow.add-task-action' | translate"
               [placeholder]="'taskflow.add-task-action-placeholder' | translate"
               [selectList]="taskTypeList"
               (focusedChange)="taskActionSelectFocusChange($event)"
               (valueChange)="addTaskAction($event); showTaskActionSelect = false">
</custom-select>
